import { render, staticRenderFns } from "./EmailVerificationSuccess.vue?vue&type=template&id=28e073e3&scoped=true"
import script from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"
export * from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationSuccess.vue?vue&type=style&index=0&id=28e073e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e073e3",
  null
  
)

export default component.exports